
import { Meta } from '../types';

export const META: Meta = {
  title: "AI Interaction Atlas",
  description: "A comprehensive library of interaction patterns for designing human-centered AI systems.",
  version: "1.0",
  schema_version: "1.1.0"
};
